import React, { useEffect, useState } from "react";
import Steps from './customSteps';
import Banner from "./banner";
import CustomOrdersShipments from "./customCardShipment";
import TwoRowButtons from "./twoRowButtons";
import ManageBoxDetials from './manageBoxDetials';
import { useDispatch, useSelector } from "react-redux";
import { fetchMyCarts } from "../../redux/reducer/cartReducer";
import { useTranslation } from "react-i18next";
import SelectAddressSection from "../accountUser/SelectAddressSection";

const ShipmentItems = ({ setSelectedMenuItem }) => {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(1);
  const [isCartEmpty, setIsCartEmpty] = useState(true);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  // const [selectedCartId, setSelectedCartId] = useState(null);
  const [selectedCartIds, setSelectedCartIds] = useState([]);

  const [tabIndex, setTabIndex] = useState(-1);
  const [getCompany, setGetCompany] = useState(null);



  const handleSelectCart = (cartId) => {
  setSelectedCartIds((prevSelected) =>
    prevSelected.includes(cartId)
      ? prevSelected.filter((id) => id !== cartId)
      : [...prevSelected, cartId]
  );
};
  
  const dispatch = useDispatch();
  const { carts } = useSelector((state) => state.carts);

  useEffect(() => {
    dispatch(fetchMyCarts());
  }, [dispatch]);
  


  const receivedCarts = carts?.filter((item) =>
  (item.status?.toLowerCase() === "received" && item.isPacking && item.isReadyToPaid) 
  ||
  (item.status?.toLowerCase() === "received" &&  !item.isPacking)
);

  useEffect(() => {
    if (receivedCarts) {
      setIsCartEmpty(carts.length === 0);
    }
  }, [receivedCarts]);


  const handleNext = () => {
    if (activeStep === 1 && selectedCartIds.length === 0) {
      alert(t("PleaseSelectACart"));
      return;
    }
  
    if (activeStep === 2 && !selectedAddressId) {
      alert(t("PleaseSelectAnAddress"));
      return;
    }
  
    if (activeStep < 3) {
      setActiveStep(activeStep + 1);
    }
  };

  const handlePrev = () => {
    if (activeStep > 1) {
      setActiveStep(activeStep - 1);
    } else {
      setSelectedMenuItem('ListOfBoxCardOrders');
    }
  };
  // console.log("Selected Address ID:", selectedAddressId);
  
  return (
    <div className="mb-5">
      <Steps activeStep={activeStep} />

      {activeStep === 1 && (
        <>
          <Banner title ={t("SelectShip")}/>
          <div className="flex flex-col gap-5 my-5">
            
            {receivedCarts.length > 0?
              receivedCarts.map((cart, index) => (
                <CustomOrdersShipments
                key={cart.id || index}
                item={cart}
                selectedCartIds={selectedCartIds}
                onSelectCart={handleSelectCart}
                />
              ))
            :
            <>
            <p className="p-2 my-4 text-sm text-center lg:text-base">{t("cartIsProcessed")}</p>
            </>
            }
          {/* <CustomOrdersShipments carts={carts}/> */}
          </div>
        </>
      )}
      {activeStep === 2 && (
        <>
          <Banner title ={t("ChooseAddress")}/>
          <SelectAddressSection onSelectAddress={setSelectedAddressId}  tagIndex={setTabIndex} />

        </>
      )}
      {activeStep === 3 && (
        <>
          <Banner title ={t("OrderSummary")}/>
          <ManageBoxDetials cartIds={selectedCartIds} getCompanyObject={setGetCompany} />
        </>
      )}

        <TwoRowButtons
          onclickNext={handleNext}
          onclickPerv={handlePrev}
          isCartEmpty={isCartEmpty}
          activeStep={activeStep}
          selectedCartIds={selectedCartIds}
          selectedAddressId={selectedAddressId}
          getCompany={getCompany}
        />
    </div>
  );
};


export default ShipmentItems;
